import { defineClientModule, type ModuleRoute } from '@/app/module';
import { registerOfflinePrefetch } from '@/lib/query';
import { copy } from './copy';

const GUEST_BEAT_MS = 15_000;

/**
 * players: roster (Crew tab), player profile, invites, crew admin, guests, the shared picker.
 * See docs/MODULE-GUIDE-client.md. Keep this file light: data and lazy imports only.
 */
const routes: ModuleRoute[] = [
  { path: '/crew', screen: () => import('./screens/Crew'), tab: 'crew' },
  { path: '/crew/invite', screen: () => import('./screens/Invite'), tab: 'crew' },
  { path: '/p/:id', screen: () => import('./screens/Profile'), tab: 'crew' },
];

export default defineClientModule({
  name: 'players',
  routes,
  homeCards: [{ id: 'invite', order: -10, component: () => import('./parts/InviteCard') }],
  meSections: [{ id: 'myCard', order: 5, title: copy.me.title, component: () => import('./parts/MyCard') }],
  slots: { 'admin.section': { order: 10, component: () => import('./parts/AdminCrew') } },
  init() {
    // The roster is the one list every setup screen needs on a court with no signal.
    registerOfflinePrefetch('players.roster', async (qc) => {
      const q = await import('./queries');
      await q.flushPendingGuests(qc);
      await qc.prefetchQuery({
        queryKey: q.playersKeys.list(),
        queryFn: () => q.fetchPlayers(),
        meta: { offline: true },
      });
    });
    // Guests added with no signal go up when signal is back, when the app comes to the front, and on
    // the same 15 s beat as the outbox, because a weak connection fires no `online` event.
    const sendGuests = () => void import('./queries').then((q) => q.flushPendingGuests());
    window.addEventListener('online', sendGuests);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') sendGuests();
    });
    setInterval(() => {
      if (document.visibilityState === 'visible') sendGuests();
    }, GUEST_BEAT_MS);
  },
});
